/**
 * The page of a research record, by its backend model name. Team members
 * and zones are sent by the backend as their request (or zone) record.
 */
const ROUTES: Record<string, (id: string) => string> = {
  LegalResearchRequest: (id) => `/conduct-legal-research/${id}`,
  InternalLegalResearchRequest: (id) => `/conduct-legal-research/internal/${id}`,
  ResearchCommitteeRequest: (id) => `/conduct-legal-research/committee/${id}`,
  DraftingInstruction: (id) => `/legislative-drafting/${id}`,
  LegalAdvisoryRequest: (id) => `/legal-advisory/${id}`,
  DirectiveAccuracyRequest: (id) => `/sector-directives/${id}`,
  DirectiveRegistrationRequest: (id) => `/registering-directives/${id}`,
  LegalTranslationRequest: (id) => `/legal-translation/${id}`,
  LawImplementationFollowUp: (id) => `/law-implementation/${id}`,
  AuditLawImplementationFollowUp: (id) => `/law-implementation/audit/${id}`,
  LegalAwareness: (id) => `/legal-awareness-creation/${id}`,
  DistrbutedZone: (id) => `/legal-awareness-creation-zone/${id}`,
  LegalTrainingProvision: (id) => `/legal-training-provision/${id}`,
  TrainingDistributedZone: (id) => `/legal-training-provision-zone/${id}`,
};

export const recordRoute = (model?: string, id?: string | number | null) =>
  model && id ? ROUTES[model]?.(String(id)) : undefined;
